import request from '../../utilities/request';
import localStorageToken from '../../utilities/storage';

const base = '/campaign-delivery';

const messageFrom = error => {
  if (!error) return 'No pudimos completar la operación.';
  if (error.error && error.error.message) return error.error.message;
  if (error.data && error.data.error && error.data.error.message) return error.data.error.message;
  if (error.data && error.data.message) return error.data.message;
  return error.message || 'No pudimos completar la operación.';
};

const call = options => request({
  ...options,
  headers: { Authorization: localStorageToken(), ...(options.headers || {}) }
}).then(payload => {
  if (!payload || payload.status !== true) {
    const error = payload && payload.error ? payload.error : { message: 'Respuesta no válida.' };
    return Promise.reject({ error });
  }
  return payload.data;
});

const get = (path, params) => call({ url: `${base}${path}`, method: 'GET', params });
const post = (path, data) => call({ url: `${base}${path}`, method: 'POST', data });
const put = (path, data) => call({ url: `${base}${path}`, method: 'PUT', data });
export const audienceQuery = (params = {}) => ({ kind: 'list', ...params });

const CampaignDeliveryService = {
  errorMessage: messageFrom,
  status: () => get('/status'),
  audiences: (params = {}) => get('/audiences', audienceQuery(params)),
  senders: params => get('/senders', params),
  sent: params => get('/sent', params),
  details: id => get(`/campaigns/${id}`),
  publish: (id, data) => post(`/campaigns/${id}/publish`, data),
  registerDesired: (id, data) => put(`/campaigns/${id}/desired`, data),
  desired: (id, data) => put(`/campaigns/${id}/desired`, data),
  sync: (id, data) => post(`/campaigns/${id}/sync`, data),
  send: (id, data) => post(`/campaigns/${id}/send`, data),
  schedule: (id, data) => post(`/campaigns/${id}/schedule`, data),
  reconcile: id => post(`/campaigns/${id}/reconcile`),
  report: id => get(`/campaigns/${id}/report`),
  recipients: (id, params) => get(`/campaigns/${id}/recipients`, params)
};

export default CampaignDeliveryService;
